import Vue from "vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";

import ECharts from "vue-echarts";
import * as echarts from 'echarts';
require('echarts-wordcloud');
Vue.prototype.$echarts = echarts;

Vue.component('v-chart', ECharts)
//Vue.use(msv);
Vue.use(ElementUI);
export default {
    create: function (selector) {
        new Vue({
            el: selector,
            router,
            render: function (h) {
                return h(App);
            },
        });
    },
};
